import React from "react";
import PropTypes from "prop-types";

const NAME_LINK_STYLE = {
	expanded: { cursor: "pointer", color: "white" },
	collapsed: { color: "rgb(17, 100, 206)", cursor: "pointer" },
};

// The "name" column is a link through to the service layout, unless the task
// has no stages to link to (disableLink).
const PlainCell = ({ col, value, toggle, disableLink, onNameClick }) => {
	const isNameLink = col === "name" && !disableLink;
	return (
		<span
			className="lastSpan"
			draggable="true"
			style={isNameLink ? NAME_LINK_STYLE[toggle ? "expanded" : "collapsed"] : {}}
			onClick={isNameLink ? onNameClick : undefined}
		>
			{value}
		</span>
	);
};

PlainCell.propTypes = {
	col: PropTypes.string.isRequired,
	value: PropTypes.node,
	toggle: PropTypes.bool.isRequired,
	disableLink: PropTypes.bool,
	onNameClick: PropTypes.func,
};

export default PlainCell;
